<app-navbar-insights *ngIf='showHeader' class='fixed-top'></app-navbar-insights>
<div [ngClass]='isInsightsLandingPage ? "container-fluid insights-container" : "container-fluid insights-container overflow-y-clip"'>
  <div class='row h-100'>
    <div class='col-12 col-md-12 col-lg-12 p-0'>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

